export const LANGUAGE_CHANGE = "languageChange";
export const ENABLE_LOADER = "enableLoader";
export const DISABLE_LOADER = "disableLoader";
export const SNACK_NOTIFICATION = "snackNotification";
export const TRIGGER_MODAL = "triggerModal";
export const TRIGGER_DIALOG = "triggerDialog";
export const LOGGED_IN = "loggedIn";
export const EXPAND_PAYMENT_PLAN_CONTRACT = "expandPaymentPlanContract";
export const OPEN_CONTRACT_MODAL = "openContractModal";
